/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForGithubProActiveScanner extends models.GovernanceConfigurationBaseForGithub {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForGithubProActiveScanner");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForGithubProActiveScanner.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForGithubProActiveScanner>): GovernanceConfigurationForGithubProActiveScanner {
        let obj = Object.assign(new GovernanceConfigurationForGithubProActiveScanner(), model);
        GovernanceConfigurationForGithubProActiveScanner.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForGithubProActiveScanner>): GovernanceConfigurationForGithubProActiveScanner {
        if (!model) return null;
        return GovernanceConfigurationForGithubProActiveScanner.newInstance(<GovernanceConfigurationForGithubProActiveScanner> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForGithubProActiveScanner) {
        if (!obj) return;

        models.GovernanceConfigurationForGithubProActiveScanner.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForGithubProActiveScanner): boolean {
        if (models.GovernanceConfigurationBaseForGithub.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForGithubProActiveScanner.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.rule_overrides) {
            for (let val of this.rule_overrides) {
                models.ProActiveScannerRule.fixupPrototype(val);
            }
        }
    }

    /**
     * list of github repository names configured for left shift scan
     */
    configured_repositories: Array<string>;

    /**
     * Specifies if the provisioning state is enabled or not
     */
    auto_provisioning_enabled: boolean;

    /**
     * List of all the Pro Active Scanner Rules
     */
    rule_overrides: Array<models.ProActiveScannerRule>;

}
